const commonHeaders = {
  'Content-Type': 'application/json',
  'x-selected-language': getMeta('selected-language') || 'en'
}

function getMeta(metaName) {
  const metas = document.getElementsByTagName('meta');

  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('name') === metaName) {
      return metas[i].getAttribute('content');
    }
  }

  return null;
}

function transformItem(item) {
  item.build.specs = item.build.specs.sort((a, b) => {
    if (a.highlight && b.highlight) {
      return 0
    } else if (a.highlight && !b.highlight) {
      return -1
    } else {
      return 1
    }
  }).filter(spec => {
    return (spec.title !== null || spec.description !== null) && !spec.highlight
  })
  item.build.short_specs = [...item.build.specs].splice(0, 9)
  item.showFullSpecs = false
  return item
}

export default {
  namespaced: true,
  state() {
    return {
      basket: null,
      products: null,
      removedItem: null,
      removedItemTitle: null,
      showPedalModal: false,
      selectedBasketItem: null,
      count: 0,
      subTotal: 0,
      euSubtotal: 0,
      discount: 0,
      taxBase: 0,
      taxes: 0,
      total: 0,
      taxTitle: "",
      taxPercent: 0,
      remaining: 0,
      paid: 0
    }
  },
  actions: {
    calculate(ctx, data) {
      let url = `${data.path}/v2/builds/prices`;
      return new Promise((resolve, reject) => {
        axios
          .post(url, {
            items: ctx.getters['products'],
            delivery_country: data.delivery_country,
            discount: {
              type: 'percent',
              value: 0
            },
            order_id: null
          }).then(result => {
          ctx.commit('setPrice', result.data.data)
          resolve(result)
        }).catch(err => {
          reject(err)
        })
      })
    },
    count({commit}, data) {
      let basketID = localStorage.getItem('basket_id');
      if (!isNaN(parseInt(basketID))) {
        basketID = null
      }
      if (basketID) {
        let url = `${data.path}/v2/baskets/${basketID}/count`;
        return new Promise((resolve, reject) => {
          axios({
            url: url,
            method: "GET",
            headers: commonHeaders,
          }).then(result => {
            commit('setBasketCount', {
              count: result.data.count
            })
            resolve(result.data)
          }).catch(error => {
            console.log(error)
            reject(error)
          })
        })
      }
    },
    addExtraToItem({commit}, data) {
      let url = `${data.path}/v2/baskets/${localStorage.getItem('basket_id')}/extra/${data.item}/add`;
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: "PUT",
          data: {
            extra: data.extra.map(item => {
              return {
                id: item.id,
                qty: 1
              }
            })
          },
          headers: commonHeaders,
        }).then(result => {
          commit('addExtraToItem', {
            item: data.item,
            extra: data.extra
          })
          commit('hidePedalModal')
          resolve(result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    removeItem({commit}, data) {
      let url = `${data.path}/v2/baskets/${localStorage.getItem('basket_id')}/delete/${data.item}`;
      let headers = {
        'Content-Type': 'application/json'
      };
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: "DELETE",
          headers: headers,
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    changeBasketItemQTY(context, data) {
      let url = `${data.path}/v2/baskets/${localStorage.getItem('basket_id')}/qty/${data.item}`;
      let headers = {
        'Content-Type': 'application/json'
      };
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: "PUT",
          data: {
            qty: data.qty
          },
          headers: headers,
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    restore({commit}, data) {
      let url = `${data.path}/v2/baskets/${localStorage.getItem('basket_id')}/restore/${data.item}`;
      let headers = {
        'Content-Type': 'application/json'
      };
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: "PUT",
          headers: headers,
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    changeExtraQTY(context, data) {
      let url = `${data.path}/v2/baskets/${localStorage.getItem('basket_id')}/extra/${data.item.id}/qty`;
      let headers = {
        'Content-Type': 'application/json'
      };
      if (!data.add && (data.extra.qty - 1) < 1) {
        return new Promise((resolve, reject) => {
          reject('To delete an item click the remove button')
        })
      }
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: "PUT",
          data: {
            extra_id: data.extra.id,
            add: data.add,
          },
          headers: headers
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    removeExtra(context, data) {
      let url = `${data.path}/v2/baskets/${localStorage.getItem('basket_id')}/extra/${data.item.id}/remove`;
      let headers = {
        'Content-Type': 'application/json'
      };
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: "PUT",
          data: {
            extra_id: data.extra.id,
          },
          headers: headers
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    generateInvoice(context, data) {
      if (localStorage.getItem('basket_id')) {
        let url = `${data.path}/v2/baskets/${localStorage.getItem('basket_id')}/invoice`;
        return new Promise((resolve, reject) => {
          axios({
            url: url,
            method: "GET",
            headers: commonHeaders
          }).then(result => {
            resolve(result.data)
          }).catch(error => {
            console.log(error)
            reject(error)
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          reject()
        })
      }
    },
    loadBasket({commit}, data) {
      if (localStorage.getItem('basket_id')) {
        let url = `${data.path}/v2/baskets/${localStorage.getItem('basket_id')}`;
        return new Promise((resolve, reject) => {
          axios({
            url: url,
            method: "GET",
            headers: commonHeaders
          }).then(result => {
            commit('setBasket', result.data)
            commit('setProducts', result.data)
            resolve(result.data)
          }).catch(error => {
            console.log(error)
            reject(error)
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          reject()
        })
      }
    },
  },
  mutations: {
    setPrice(state, prices) {
      state.subTotal = prices.subtotal;
      state.euSubtotal = prices.eu_subtotal;
      state.discount = prices.discount;
      state.taxBase = prices.tax_base;
      state.taxes = prices.taxes;
      state.total = prices.total;
      state.taxTitle = prices.tax_title;
      state.taxPercent = prices.tax_percent;
      state.remaining = prices.remaining;
      state.paid = prices.paid;
    },
    setBasketCount(state, data) {
      if (data.count > 9) {
        state.count = '9+'
      } else {
        state.count = data.count
      }
      state.count = data.count
    },
    addOrUpdateItem(state, item) {
      let exist = false
      state.basket.items = state.basket.items.map(bi => {
        if (bi.id === item.id) {
          bi.qty++
          exist = true
        }
        return bi
      })

      if (!exist) {
        state.basket.items.push(item)
      }
    },
    setSelectedBasketItem(state, item) {
      state.selectedBasketItem = item
    },
    togglePedalModal(state) {
      state.showPedalModal = !state.showPedalModal
    },
    hidePedalModal(state) {
      state.showPedalModal = false
    },
    addExtraToItem(state, data) {
      let tmpBasket = {...state.basket}

      tmpBasket.items.map(item => {
        if (item.id === data.item) {
          for (let extra of data.extra) {
            let exist = false
            item.extra = item.extra.map(ex => {
              if (ex.id === extra.id) {
                ex.qty++
                exist = true
              }
              return ex
            })

            if (!exist) {
              item.extra.push({...extra, ...{qty: 1}})
            }
          }
        }
        return item
      })

      state.basket = tmpBasket
    },
    removeExtra(state, data) {
      state.basket.items = state.basket.items.map(item => {
        if (item.id === data.item.id) {
          item.extra = item.extra.filter(extra => {
            return extra.id !== data.extra.id
          })
        }
        return item
      })
    },
    changeExtraQTY(state, data) {
      let remove = false;
      state.basket.items = state.basket.items.map(item => {
        if (item.id === data.item.id) {
          item.extra = item.extra.map(extra => {
            if (extra.id === data.extra.id) {
              let currentQTY = extra.qty
              let newQTY = data.add ? currentQTY + 1 : currentQTY - 1
              if (newQTY <= 0) {
                newQTY = 0
                remove = true
              }
              extra.qty = newQTY
            }
            return extra
          })
          if (remove) {
            item.extra.filter(extra => {
              return extra.id !== data.extra.id
            })
          }
        }
        return item
      })
    },
    changeLocalItemQTY(state, data) {
      state.basket.items[data.index].qty = data.qty
    },
    hideItem(state, item) {
      state.basket.items = state.basket.items.filter(basketItem => {
        return basketItem.id !== item.id
      })
    },
    appendToBasket(state, item) {
      state.basket.items.push(transformItem(item))
    },
    setRemovedItem(state, data) {
      state.removedItem = data.id
      state.removedItemTitle = data.title
    },
    toggleShowingFullSpecForOption(state, index) {
      state.basket.items[index].showFullSpecs = !state.basket.items[index].showFullSpecs
    },
    setProducts(state, data) {
      if (!data || !data.items) {
        return;
      }

      state.products = data.items.map(item => {
        return {
          id: null,
          build_id: item.build.id,
          qty: item.qty,
          custom_price: item.custom_price
        }
      })
    },
    setBasket(state, data) {
      let basket
      if (data.hasOwnProperty('basket')) {
        basket = data.basket
      } else {
        basket = data
      }

      if (!basket || !basket.items) {
        return;
      }

      basket.items.map(item => {
        return transformItem(item)
      })

      state.basket = basket
    }
  },
  getters: {
    products(state) {
      return state.products
    },
    items(state) {
      return state.basket ? state.basket.items : []
    },
    showPedalModal(state) {
      return state.showPedalModal
    },
    selectedBasketItem(state) {
      return state.selectedBasketItem
    },
    count(state) {
      return state.count
    },
    subTotal: state => state.subTotal,
    euSubtotal: state => state.euSubtotal,
    discount: state => state.discount,
    taxBase: state => state.taxBase,
    taxes: state => state.taxes,
    total: state => state.total,
    taxTitle: state => state.taxTitle,
    taxPercent: state => state.taxPercent,
    remaining: state => state.remaining,
    paid: state => state.paid,
  }
}
